export default __webpack_public_path__ + "static/media/heart-light.cdb68825.svg";